<template>
  <div class="flex">
    <el-input v-model="string" />
    <el-select
      v-model="selected"
      style="width: 100%"
      @change="onChange"
      :placeholder="selectHolder"
      :disabled="!string"
    >
      <el-option
        v-for="item in items"
        :key="item"
        :label="enumFilter(name, item)"
        :value="item"
      />
    </el-select>
  </div>
</template>

<script>
import { enumFilter } from "@/utils/filters";

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      required: false,
      default: null,
    },
    name: {
      type: String,
      required: false,
      default: null,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    defaultValue: {
      type: String,
      required: false,
      default: null,
    },
    defaultSelect: {
      type: String,
      required: false,
      default: null,
    },
    selectHolder: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      selectValue: "",
    };
  },
  computed: {
    options() {
      return Array.isArray(this.data) ? this.data : [];
    },
    string: {
      get() {
        return this.value;
      },
      set(val) {
        if (!val) {
          this.selected = null;
        }
        this.$emit("input", val);
      },
    },
    selected: {
      get() {
        return this.selectValue;
      },
      set(val) {
        if (val === "start") this.string = "{code}" + this.string;
        if (val === "end") this.string = this.string + "{code}";
        if (val === "both") this.string = "{code}" + this.string + "{code}";
        this.selectValue = val;
      },
    },
  },
  created() {
    if (this.defaultValue) this.string = this.defaultValue;
    if (this.defaultSelect) this.selected = this.defaultSelect;
  },
  methods: {
    enumFilter,
    onChange(val) {
      this.selectValue = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
</style>
